export default __webpack_public_path__ + "static/media/topsecret.ee7fec0c.png";